import type { PurchasingPurchaseLineRow } from '@/services/purchasingTypes'

export type PriceSparkPoint = {
  date: string
  value: number
}

function last90DayCutoff(): string {
  const cutoff = new Date()
  cutoff.setDate(cutoff.getDate() - 90)
  return cutoff.toISOString().slice(0, 10)
}

export function buildPriceSparklinePoints(lines: PurchasingPurchaseLineRow[]): PriceSparkPoint[] {
  const cutoff = last90DayCutoff()
  return lines
    .filter(
      (line) =>
        line.invoice_date >= cutoff &&
        line.cost_per_atomic_unit != null &&
        Number.isFinite(Number(line.cost_per_atomic_unit)),
    )
    .map((line) => ({
      date: line.invoice_date,
      value: Number(line.cost_per_atomic_unit),
    }))
    .sort((a, b) => a.date.localeCompare(b.date))
}
